import React, { useContext, useEffect, useState } from "react";
import { CommonModal } from "../../../AbstractElements";
import { Row, Col, FormGroup, Label, Form } from "reactstrap";
import { formatDateTime, showAlert } from "../../../Services/Shared.service";
import { deleteDriver, rechargeDriver } from "../../../Services/Driver.service";
import { useForm } from "react-hook-form";
import SharedDataContext from "../../../_helper/SharedData";
import moment from "moment";

const RechargeModal = ({ Large, title, LargeModaltoggle, driverObj, fetchData, isAmountPopulate, populateAmount,totalCommissionAmount }) => {
    const {
        register,
        handleSubmit,
        control,
        reset,
        resetField,
        getValues,
        setValue,
        watch,
        formState: { errors },
    } = useForm({
        amount: "",
        remarks: ""
    });
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { dateFilter } = useContext(SharedDataContext);
    const localFromDate = moment(dateFilter.startDate).set({ h: 0, m: 0, s: 0, ms: 0 });
    const localToDate = moment(dateFilter.endDate).set({ h: 23, m: 59, s: 59, ms: 999 });
    const FormatFromDate = formatDateTime(
        localFromDate,
        "YYYY-MM-DD"
    );
    const FormatToDate = formatDateTime(localToDate, "YYYY-MM-DD");

    useEffect(() => {
        if (isAmountPopulate) {
            reset({
                amount: populateAmount,
                remarks: ""
            })
        }
    }, [isAmountPopulate])

    const onSubmit = (formValues) => {
        setIsSubmitting(true)
        const obj = {
            rechargeDriverId: driverObj.id,
            amount: Number(formValues.amount),
            transactionType: "Recharge",
            transactionMode: 1,
            isAirportCounter: true,
            paymentType: "Cash",
            remarks: formValues.remarks,
            isDriverCollectableRecharge: isAmountPopulate ? true : false,
            fromDate: FormatFromDate,
            toDate: FormatToDate,
            commission: totalCommissionAmount ? Number(totalCommissionAmount) : null
        };
        rechargeDriver(obj).then(result => {
            setIsSubmitting(false);
            reset()
            showAlert('success', 'Driver recharged Successfully');
            LargeModaltoggle();
        }).catch(err => {
            setIsSubmitting(false)
            showAlert('error', err.response?.data?.message ? err.response.data.message : 'Something went wrong');
        })
    }


    return (
        <CommonModal
            isOpen={Large}
            title={title}
            toggler={LargeModaltoggle}
            size="md"
        >
            <Form onSubmit={handleSubmit(onSubmit)}>
                <FormGroup className="col-lg-12">
                    <Label className="col-lg-4 col-form-label">
                        Driver Name
                    </Label>
                    <Col lg="12">
                        <input
                            className="form-control"
                            type="text"
                            disabled={true}
                            value={driverObj.fullName}
                        />
                        <span style={{ color: "red" }}>
                            {errors?.phoneNumber?.message}
                        </span>
                    </Col>
                </FormGroup>
                <FormGroup className="col-lg-12">
                    <Label className="col-lg-12 col-form-label">Recharge Amount</Label>
                    <Col lg="12">
                        <input
                            className="form-control"
                            type="text"
                            {...register("amount", {
                                required: {
                                    value: true,
                                    message: "Recharge Amount is required",
                                },
                                onChange: (e) => {
                                    let value = e.target.value.replace(/[^\d.-]/g, '');
                                    let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, '');
                                    setValue("amount", sanitizedValue)
                                },
                            })}
                            disabled={isAmountPopulate ? true : false}
                        />
                        <span style={{ color: "red" }}>{errors?.amount?.message}</span>
                    </Col>
                </FormGroup>
                <FormGroup className="col-lg-12">
                    <Label className="col-lg-12 col-form-label">Remarks</Label>
                    <Col lg="12">
                        <textarea
                            className="form-control"
                            {...register("remarks", {
                                required: {
                                    value: true,
                                    message: "Remarks is required"
                                },
                                onChange: (e) => {
                                    setValue("remarks", e.target.value.trimStart())
                                }
                            })}
                            type="text"
                        />
                        <span style={{ color: "red" }}>{errors?.remarks?.message}</span>
                    </Col>
                </FormGroup>
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" className="btn submit-button" disabled={isSubmitting}>
                        Recharge
                    </button>
                </div>
            </Form>
        </CommonModal>
    );
};

export default RechargeModal;
